/* Konfigurator B: Thumbnails unter dem grossen Bild (10.09.2026, Philipp: wie auf der Produktseite).
   Liest die Zellen des Flickity-Karussells (.eh-visual-stage), baut darunter eine Leiste, haelt sie bei jedem
   Neuaufbau der Buehne (Groesse/Holzart/Modell) aktuell und markiert die aktive Zelle. */
(function () {
  'use strict';
  var stage = document.querySelector('.eh-visual-stage');
  if (!stage || !stage.parentElement) return;
  var leiste = document.createElement('div'); leiste.className = 'ehb-thumbs'; leiste.setAttribute('aria-label', 'Bilder');
  stage.parentElement.insertBefore(leiste, stage.nextSibling);
  var flkty = null; var uhr = null;
  function instanz() { try { return (window.Flickity && window.Flickity.data(stage)) || null; } catch (e) { return null; } }
  function kleiner(u) { return String(u || '').replace(/([?&]width=)\d+/, '$1200'); }
  function bauen() {
    flkty = instanz(); if (!flkty) return;
    var zellen = flkty.cells || []; var html = '';
    zellen.forEach(function (c, i) {
      var el = c.element; var v = el.querySelector('video'); var img = el.querySelector('img');
      var src = v ? (v.getAttribute('data-eh-poster') || v.getAttribute('poster') || '') : (img ? (img.getAttribute('data-flickity-lazyload') || img.getAttribute('src') || '') : '');
      if (!src) return;
      html += '<button type="button" class="ehb-thumb' + (i === flkty.selectedIndex ? ' aktiv' : '') + '" data-ehb-thumb="' + i + '" aria-label="Bild ' + (i + 1) + '"><img src="' + kleiner(src) + '" alt="" loading="lazy">' + (v ? '<span class="ehb-thumb__play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>' : '') + '</button>';
    });
    leiste.innerHTML = html;
    if (!flkty.__ehbThumbs) { flkty.__ehbThumbs = true; flkty.on('select', markieren); }
  }
  function markieren() {
    if (!flkty) return;
    var i = flkty.selectedIndex;
    [].forEach.call(leiste.querySelectorAll('[data-ehb-thumb]'), function (t) { t.classList.toggle('aktiv', +t.getAttribute('data-ehb-thumb') === i); });
    var a = leiste.querySelector('.ehb-thumb.aktiv'); if (a && a.scrollIntoView) { try { a.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
  }
  leiste.addEventListener('click', function (ev) { var t = ev.target.closest('[data-ehb-thumb]'); if (!t || !flkty) return; flkty.select(+t.getAttribute('data-ehb-thumb')); });
  /* Neuaufbau der Buehne erkennen (renderImageSubset tauscht alle Zellen). */
  var beobachter = new MutationObserver(function () { clearTimeout(uhr); uhr = setTimeout(bauen, 150); });
  beobachter.observe(stage, { childList: true, subtree: true });
  var versuche = 0; (function warten() { if (instanz()) { bauen(); return; } if (versuche++ < 60) setTimeout(warten, 250); })();
})();
